import { Pipe, PipeTransform } from '@angular/core';
import { TicketBase, TicketList } from '../_interfaces/ticket';

import dayjs from '../_utils/dayjs.config';
import { WorkstepContent } from '../_template/ticket-detail/workstep-content/workstep-content.component';
import { Attachment } from '../_interfaces/Attachment';
import { TicketEmployee } from '../_provider/tickets/ticket.service';

@Pipe({
  name: 'ticketSort'
})
export class TicketSortPipe implements PipeTransform {

  constructor(private ticketSrv: TicketEmployee.TicketService){}

  transform(tickets: TicketBase[], ...args: any[]): TicketBase[] {

    const now: Date = new Date()


    switch (args[0]) {
      case "today":
        return tickets.filter(t => dayjs(now).format("DD-MM-YYYY") == dayjs(t.lastUpdate).format("DD-MM-YYYY") && !this.isCurrentlyFixed(t.id))
      case "yesterday":
        return tickets.filter(t => dayjs(now).add(-1, "day").format("DD-MM-YYYY") == (dayjs(t.lastUpdate).format("DD-MM-YYYY")) && !this.isCurrentlyFixed(t.id))
      case "lastSevenDays":
        return tickets.filter(t => dayjs(t.lastUpdate).isBetween(dayjs(now).add(-7, "day").format("YYYY-MM-DD"), dayjs(now).add(-1, "day").format("YYYY-MM-DD"))&& !this.isCurrentlyFixed(t.id))
      case "older":
        return tickets.filter(t => dayjs(now).add(-8, "day").isSameOrAfter(dayjs(t.lastUpdate), "day") && !this.isCurrentlyFixed(t.id))
      case "pinned":
        return tickets.filter(t => this.ticketSrv.pinnedTicketIds.find(pt => pt == t.id))
      default:
        break;
    }
  }

  private isCurrentlyFixed(ticketId: number): boolean{
    return this.ticketSrv.pinnedTicketIds.find(id=>id == ticketId) != undefined
  }

}

@Pipe({
  name: "ticketSortState"
})
export class TicketSortState implements PipeTransform{
  transform(tickets: TicketBase[], ...args: any[]) {

    
    switch (args[0]) {
      case "open":
        return tickets.filter(t => !t.isClosed)
      case "closed":
        return tickets.filter(t => t.isClosed)
      default:
        break;
    }
  }

}